import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { ConfigProvider } from "antd";



const root = ReactDOM.createRoot(document.getElementById("root"));


root.render(
  <React.StrictMode>
    {/* <Provider store={store}> */}
    {/* <ConfigProvider
                     theme={{
                       token: {
                         colorPrimary: "#52c41a", // Green color
                         colorPrimaryHover: "#40a700", // Darker green on hover
                        //  colorBgContainer: isdarkMode === "dark" ? "#292c35" : "#f6ffed",
                        //  colorTextBase: isdarkMode === "dark" ? "#fff" : "#000",
                       },
                     }}
                   > */}
                     <App/>
                   {/* </ConfigProvider> */}
    {/* </Provider> */}
  </React.StrictMode>
);


